<template>
    <div class="bg-white rounded shadow  container-box">
        <div class="row" v-if="!isTherapist">
            <div class="col-md-12 mb-2">
                <!--<mdc-tab-bar>
                    <mdc-tab :active="'protocols' === route.name" :to="{name: 'protocols'}">{{'protocol.protocols' |
                        trans}}
                    </mdc-tab>
                    <mdc-tab :active="'bids' === route.name" :to="{name: 'bids'}">{{'protocol.bids' | trans}}</mdc-tab>
                </mdc-tab-bar>-->
  
              <nav class="mdc-tab-bar mdc-tab-bar-upgraded">
    
                <router-link class="mdc-tab mdc-ripple-upgraded" :to="{name: 'protocols'}"
                             :class="{'mdc-tab--active': 'protocols' === route.name}">
                  <span>{{'protocol.protocols' | trans}}</span></router-link>
    
                <router-link class="mdc-tab mdc-ripple-upgraded"
                             :to="{name: 'bids'}"
                             :class="{'mdc-tab--active': 'bids' === route.name}">
                  <span>{{'protocol.bids' | trans}}</span></router-link>
              </nav>
              
              
                <hr>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex';

export default {
  name: 'DashboardBCBA',
  computed: {
    ...mapGetters('auth', [
      'isTherapist'
    ]),
    ...mapState([
      'route',
    ]),
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/protocols/components/ProtocolDashboardLayout.vue